<thr-loading [show]="loader.isLoading()"></thr-loading>
<thr-header-onboarding
    [agent]="user"
    [contract]="contract"
    [showBack]="showBack"
    (back)="onBack()"
    *ngIf="!isClientPortal"
></thr-header-onboarding>
<thr-header-onboarding-client-portal
    [user]="user"
    [contract]="contract"
    [showBack]="showBack"
    (back)="onBack()"
    *ngIf="isClientPortal"
></thr-header-onboarding-client-portal>

<router-outlet></router-outlet>
